import { userRoleEnums } from '@/resources/enums/userRole'
import OrderStatusEnum from '@/resources/enums/orderStatus'
import ALLOWED_OPERATIONAL_STATUS from '@/resources/enums/pocAcceptedOperationalStatus'
import ALL_POC_OPERATIONAL_STATUS from '@/resources/enums/pocAllPossibleStatus'
import { DeliveryType } from '@/resources/enums'

export const SELLER_DATA = 'SELLER_DATA'
export const STORE_OPEN_STATUS = 'STORE_OPEN_STATUS'

export const orderHasAlreadyBeenAccepted = statusHistory =>
  statusHistory?.some(({ status }) => status === OrderStatusEnum.POC_ACCEPTED)

export const isOperationalPoc = status => status in ALLOWED_OPERATIONAL_STATUS

export const isRegisteredPoc = status =>
  status === ALL_POC_OPERATIONAL_STATUS.REGISTERED

export const userRole = role =>
  role === userRoleEnums.OWNER ? 'Financial' : 'Operational'

export const hasScheduledDelivery = (deliveryMethods, hasTwinSeller) =>
  deliveryMethods?.includes(DeliveryType.SCHEDULED) || hasTwinSeller

export const hasTurboDelivery = (deliveryMethods = []) =>
  deliveryMethods?.includes(DeliveryType.TURBO)

export const hasPickupDelivery = (deliveryMethods = []) =>
  deliveryMethods?.includes(DeliveryType.PICKUP)
